import { Divider } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as ColourSelectorGrid from './M_ColourSelectorGrid';
import * as PartsList from './M_PartsList';
import { imageValue } from './domain/propertyOption/option';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (p) {
    var t = useTranslations().t;
    var colours = p.heroProperties.filter(function (h) { return h.options.find(function (o) { var _a; return ((_a = o.display) === null || _a === void 0 ? void 0 : _a.kind) === 'swatch'; }); });
    var properties = p.heroProperties.filter(function (h) { return !colours.includes(h); });
    var propertiesMetadata = properties
        .map(function (h) {
        var _a;
        var active = h.options.find(function (o) { return o.status === 'active'; });
        var activeImage = (active === null || active === void 0 ? void 0 : active.displayName) === 'furniture.option.none'
            ? 'assets/cross.png'
            : active
                ? imageValue(active)
                : undefined;
        return {
            id: h.name,
            thumbnail: activeImage ? activeImage : '',
            label: h.displayName,
            subtitle: ((_a = h.options.find(function (o) { return o.status === 'active'; })) === null || _a === void 0 ? void 0 : _a.displayName) ||
                t('property.error.message'),
            optionsCount: h.options.length,
            alwaysDisplay: h.alwaysDisplay,
        };
    })
        .filter(function (p) { return p.alwaysDisplay || p.optionsCount >= 2; });
    return (Preact.h(Box, null,
        colours.length > 0 &&
            colours.map(function (colour, index) { return (Preact.h(ColourSelectorGrid.Component, { colours: colour, onClick: function (colour) {
                    if (p.onHeroPartOptionClick) {
                        p.onHeroPartOptionClick(colour.id, colours[index].name, colour.compatible);
                    }
                    p.trackVariantSelection({ colourValue: colour.id });
                } })); }),
        propertiesMetadata.length > 0 && (Preact.h(PartsList.Component, { partsMetadata: propertiesMetadata, onPartClick: p.onHeroPropsClick, reorderDimensions: p.reorderDimensions })),
        Preact.h(Divider, null)));
};
Component.displayName = 'HeroPropertySelections';
